import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Padding } from '../Padding';
import { colorGray } from '@atlas-frontend/design-tokens';

export type ModalHeaderProps = PropsWithChildren;

export const ModalHeader: FC<ModalHeaderProps> = (props) => (
  <StyledHeader horizontal vertical={17} {...props} />
);

const StyledHeader = styled(Padding)`
  border-bottom: 1px solid ${colorGray[1]};
`;
